import { ToastTypes } from '@office-start/toast-types';
export var createErrorNotification = function (message, actionInfo) {
    return {
        message: message,
        actionInfo: actionInfo,
        type: ToastTypes.Error,
    };
};
export var createLoadingNotification = function (message, actionInfo) {
    return {
        message: message,
        actionInfo: actionInfo,
        type: ToastTypes.InProgress,
    };
};
export var createSuccessNotification = function (message, actionInfo, linkInfo) {
    return {
        message: message,
        actionInfo: actionInfo,
        linkInfo: linkInfo,
        type: ToastTypes.Success,
    };
};
//# sourceMappingURL=actionCreators.js.map